/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

function CardsSimpleImage (props) {
    
    const { image } = props;
    const width = 48;
    const { alt, title, url } = image || {};

    return (
        <Fragment>
            {image && (
                <div className='cards-image-container'>
                    <img
                        alt={alt}
                        title={title}
                        width={width}
                        src={url}
                    />
                </div>
            )}
        </Fragment>
    );
}

export { CardsSimpleImage };
